import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Textarea } from '../components/ui/textarea';
import { ArrowLeft } from 'lucide-react';
import { toast } from 'sonner';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function AddAdvertiser() {
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    image_url: '',
    price: '',
    url: ''
  });
  const [loading, setLoading] = useState(false);
  const { getAuthHeader } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await axios.post(
        `${API_URL}/api/admin/advertisers`,
        { ...formData, price: parseFloat(formData.price) },
        { headers: getAuthHeader() }
      );
      toast.success('Advertiser product added successfully!');
      navigate('/admin');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to add product');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background py-12 px-4">
      <div className="max-w-2xl mx-auto">
        <Button
          variant="ghost"
          onClick={() => navigate('/admin')}
          className="mb-8 text-foreground hover:text-primary"
        >
          <ArrowLeft className="mr-2" /> Back to Admin Panel
        </Button>

        <div className="wm-card p-8 rounded-lg card-shadow border border-primary/20">
          <h1 className="text-3xl font-playfair font-bold text-foreground mb-6">
            Add Advertiser Product
          </h1>

          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <Label htmlFor="name" className="text-foreground">Product Name</Label>
              <Input
                id="name"
                value={formData.name}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                required
                className="mt-1 bg-input border-border text-foreground"
                data-testid="name-input"
              />
            </div>

            <div>
              <Label htmlFor="description" className="text-foreground">Description</Label>
              <Textarea
                id="description"
                value={formData.description}
                onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                required
                rows={3}
                className="mt-1 bg-input border-border text-foreground"
                data-testid="description-input"
              />
            </div>

            <div>
              <Label htmlFor="image_url" className="text-foreground">Image URL</Label>
              <Input
                id="image_url"
                type="url"
                value={formData.image_url}
                onChange={(e) => setFormData({ ...formData, image_url: e.target.value })}
                required
                className="mt-1 bg-input border-border text-foreground"
                placeholder="https://example.com/image.jpg"
                data-testid="image-url-input"
              />
            </div>

            <div>
              <Label htmlFor="price" className="text-foreground">Price ($)</Label>
              <Input
                id="price"
                type="number"
                step="0.01"
                value={formData.price}
                onChange={(e) => setFormData({ ...formData, price: e.target.value })}
                required
                className="mt-1 bg-input border-border text-foreground"
                data-testid="price-input"
              />
            </div>

            <div>
              <Label htmlFor="url" className="text-foreground">Product URL</Label>
              <Input
                id="url"
                type="url"
                value={formData.url}
                onChange={(e) => setFormData({ ...formData, url: e.target.value })}
                required
                className="mt-1 bg-input border-border text-foreground"
                placeholder="https://example.com/product"
                data-testid="url-input"
              />
            </div>

            <Button
              type="submit"
              disabled={loading}
              className="w-full bg-primary text-primary-foreground hover:bg-primary/90 font-semibold"
              data-testid="submit-btn"
            >
              {loading ? 'Adding...' : 'Add Product'}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
